import React from "react";
import { useTranslation } from "react-i18next";
import { formatToLocalDateTime } from "../utils/formatDate";
import Loader from "../../../components/Loader";
import edit from "../../../assets/edit.png";

interface AdminTableProps {
  tableData: any;
  loading: boolean;
  handleEditEmoloyee: (id: string) => void;
}
const EmployeeTable: React.FC<AdminTableProps> = ({
  tableData,
  loading,
  handleEditEmoloyee,
}) => {
  const { t } = useTranslation();
  return (
    <div className="h-[65vh] md:h-[67vh] overflow-auto page-container p-2 pt-0 scrollbar scrollbar-thin">
      <table className="min-w-full bg-white border border-black-200 table-auto border-separate border-spacing-0">
        <thead className="bg-gray-200 sticky top-[0px] z-20">
          <tr>
            <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-nowrap">
              Employee ID
            </th>
            <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500">
              Name (English)
            </th>
            <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
              Name (Arabic)
            </th>
            <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
              Email Address
            </th>
            <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500">
              Mobile Number
            </th>
            <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500">
              Position ID
            </th>
            <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500">
              Position Name
            </th>
            <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500">
              Channel ID
            </th>
            <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500">
              Channel Name
            </th>
            <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500">
              Sales Office ID
            </th>
            <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500">
              Sales Office Name
            </th>
            <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500">
              Supervisor ID
            </th>
            <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500">
              Supervisor Name
            </th>
            <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500">
              Employment Status
            </th>
            <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500">
            Allow Collection Only
            </th>
            <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-nowrap">
              Unplanned approval required
            </th>
            <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-nowrap">
              Unplanned visit limit
            </th>
            <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-nowrap">
              Training video completed
            </th>
            <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-nowrap">
              Planning type
            </th>
            <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500">
              Created At
            </th>
            <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500">
              Updated At
            </th>
            <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500">
              Edit
            </th>
          </tr>
        </thead>
        {loading ? (
          <tbody>
            <tr>
              <td colSpan={22} className="py-8">
                <div className="flex justify-center items-center w-full">
                  <Loader />
                </div>
              </td>
            </tr>
          </tbody>
        ) : !loading && tableData?.items?.length === 0 ? (
          <tr>
            <td colSpan={22} className="py-8 text-center text-gray-500">
              No results found
            </td>
          </tr>
        ) : (
          <tbody>
            {Array.isArray(tableData?.items) &&
              tableData.items.map((item: any, index: number) => (
                <tr key={index} className="border-b text-sm">
                  <td className="border border-gray-300 px-4 py-2">{item.emp_id || "-"}</td>
                  <td className="border border-gray-300 px-4 py-2">{item.name_eng || "-"}</td>
                  <td className="border border-gray-300 px-4 py-2">{item.name_arb || "-"}</td>
                  <td className="border border-gray-300 px-4 py-2">{item.email || "-"}</td>
                  <td className="border border-gray-300 px-4 py-2">{item.mobile_number || "-"}</td>
                  <td className="border border-gray-300 px-4 py-2">{item.position_id || "-"}</td>
                  <td className="border border-gray-300 px-4 py-2">{item.position_name || "-"}</td>
                  <td className="border border-gray-300 px-4 py-2">{item.channel_id || "-"}</td>
                  <td className="border border-gray-300 px-4 py-2">{item.channel_name || "-"}</td>
                  <td className="border border-gray-300 px-4 py-2">{item.sales_office_id || "-"}</td>
                  <td className="border border-gray-300 px-4 py-2">{item.sales_office_name || "-"}</td>
                  <td className="border border-gray-300 px-4 py-2">{item.supervisor_id || "-"}</td>
                  <td className="border border-gray-300 px-4 py-2">{item.supervisor_name || "-"}</td>
                  <td className="border border-gray-300 px-4 py-2">{item.status || "-"}</td>
                  <td className="border border-gray-300 px-4 py-2">
                    {item.only_collection_allowed === true || item.only_collection_allowed === "true" 
                      ? "Yes" 
                      : item.only_collection_allowed === false || item.only_collection_allowed === "false" 
                      ? "No" 
                      : "-"}
                  </td>
                  <td className="border border-gray-300 px-4 py-2">
                    {item.unplanned_approval_required === true ||
                    item.unplanned_approval_required === "true"
                      ? "Yes"
                      : item.unplanned_approval_required === false ||
                          item.unplanned_approval_required === "false"
                        ? "No"
                        : "-"}
                  </td>
                  <td className="border border-gray-300 px-4 py-2">
                    {item.unplanned_visit_limit != null && item.unplanned_visit_limit !== ""
                      ? String(item.unplanned_visit_limit)
                      : "-"}
                  </td>
                  <td className="border border-gray-300 px-4 py-2">
                    {item.is_training_video_completed === true ||
                    item.is_training_video_completed === "true"
                      ? "Yes"
                      : item.is_training_video_completed === false ||
                          item.is_training_video_completed === "false"
                        ? "No"
                        : "-"}
                  </td>
                  <td className="border border-gray-300 px-4 py-2 max-w-[140px] truncate" title={item.planning_type ?? ""}>
                    {item.planning_type != null && item.planning_type !== "" ? String(item.planning_type) : "-"}
                  </td>
                  <td className="border border-gray-300 px-4 py-2">
                    {formatToLocalDateTime(item.created_at) || "-"}
                  </td>
                  <td className="border border-gray-300 px-4 py-2">
                    {formatToLocalDateTime(item.updated_at) || "-"}
                  </td>
                  <td
                    onClick={() => handleEditEmoloyee(item.emp_id)}
                    className="border border-gray-300 px-4 py-2 cursor-pointer"
                  >
                    <img className="w-4" src={edit} alt="edit" />
                  </td>
                </tr>
              ))}
          </tbody>
        )}
      </table>
    </div>
  );
};

export default EmployeeTable;
